import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getTests, getProjects } from "../../services/api";
import Breadcrumbs from "../../components/BreadCrumbs";
import { formatDate } from "../../utils/utils";

const TestList = () => {
  const [tests, setTests] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Estado para manejar errores

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtener los tests y proyectos en paralelo
        const [testsResponse, projectsResponse] = await Promise.all([
          getTests(),
          getProjects(),
        ]);

        setTests(testsResponse); // Guardar tests
        setProjects(projectsResponse); // Guardar proyectos
        setLoading(false);
      } catch (error) {
        setError("Error al obtener los casos de prueba");
        console.error("Error al obtener los casos de prueba", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Función para encontrar el nombre del proyecto correspondiente
  const findProjectName = (projectId) => {
    const project = projects.find((p) => p.proyectos_id === projectId);
    return project ? project.nombre : "Sin Proyecto"; // Retorna el nombre o 'Sin Proyecto' si no se encuentra
  };

  if (loading) return <div>Cargando...</div>; // Mensaje de carga

  if (error) return <p>{error}</p>; // Muestra el mensaje de error si ocurrió algún problema

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Test", url: "/dashboard/test" },
  ];

  return (
    <>
      <Breadcrumbs paths={breadcrumbPaths} />

      <h3>Casos de Prueba</h3>
      {/*<Link
        to={`/projects/${projectId}/tests/create`}
        className="btn btn-primary mb-3"
      >
        Crear Caso de Prueba
      </Link>*/}

      {tests && tests.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Fecha de creación</th>
              <th>proyectos_id</th>
              <th>Asignado a</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tests.map((test) => (
              <tr key={test.caso_prueba_id}>
                <td>{test.caso_prueba_id}</td>
                <td>{test.nombre}</td>
                <td>{test.descripcion}</td>
                <td>{formatDate(test.createdAt)}</td>
                <td>{findProjectName(test.proyectos_id)}</td>
                <td>{test.assignedTo}</td>
                <td>{test.estado}</td>
                <td>
                  <Link
                    to={`/dashboard/projects/${test.proyectos_id}/tests/update/${test.caso_prueba_id}`}
                    className="btn btn-sm btn-secondary ml-2"
                  >
                    Editar
                  </Link>
                  <Link
                    to={`/dashboard/projects/${test.proyectos_id}/tests/delete/${test.caso_prueba_id}`}
                    className="btn btn-sm btn-danger ml-2"
                  >
                    Eliminar
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay proyectos disponibles.</p>
      )}
    </>
  );
};

export default TestList;
